import { useEffect } from 'react';

/**
 * Custom hook to scroll to top when specific dependencies change
 * Useful for pages that need to scroll to top on state changes
 * 
 * @param {Array} dependencies - Array of values to watch for changes
 * @param {boolean} enabled - Whether the scroll behavior is enabled (default: true)
 */
const useScrollToTop = (dependencies = [], enabled = true) => {
  useEffect(() => {
    if (enabled) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
  }, dependencies);
};

export default useScrollToTop;
